import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Field, Alert, Progress } from "@evolua/ui";
import { AuthApiError, passwordConfirm } from "../../auth/auth-api.js";
import { getAuthMode } from "../../auth/config.js";
import { AuthLayout } from "./AuthLayout.js";

export function ResetPasswordPage() {
  const mode = getAuthMode();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      if (mode === "demo") {
        setError("Modo demo: use VITE_AUTH_MODE=api para redefinir senha na API.");
        return;
      }
      await passwordConfirm({
        email: email.trim(),
        code: code.trim(),
        newPassword,
      });
      navigate("/login", { replace: true });
    } catch (err) {
      setError(
        err instanceof AuthApiError
          ? err.detail || "Não foi possível atualizar a senha."
          : "Falha de rede.",
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <AuthLayout
      title="Nova senha"
      lead="Use o código recebido por e-mail (ou o devToken em ambiente local)."
    >
      <form className="evolua-auth__form" onSubmit={onSubmit}>
        <Field
          label="E-mail"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Field
          label="Código"
          autoComplete="one-time-code"
          required
          minLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <Field
          label="Nova senha"
          type="password"
          autoComplete="new-password"
          required
          minLength={12}
          hint="Mínimo 12 caracteres."
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <Progress
          value={Math.min(12, newPassword.length)}
          max={12}
          label="Requisito mínimo de 12 caracteres"
        />
        <ul className="evolua-auth__reqs">
          <li>
            {newPassword.length >= 12
              ? "Comprimento adequado"
              : "Ainda abaixo de 12 caracteres"}
          </li>
        </ul>
        {error ? <Alert tone="danger">{error}</Alert> : null}
        <Button type="submit" loading={pending}>
          Atualizar senha
        </Button>
      </form>
      <div className="evolua-auth__links">
        <Link to="/recuperar-senha">Pedir novo código</Link>
        <Link to="/login">Voltar ao login</Link>
      </div>
    </AuthLayout>
  );
}
